import axios from 'axios';
import { toast } from 'react-toastify';
import { config } from '../../../../config/envs';

// O checkout real (boleto) é feito direto no jusSub, sem passar pelo gateway.
const JUSSUB_BASE_URL = config.jussub.apiUrl;

export class CheckoutAPI {
  static async createWithPlan(payload) {
    try {
      // Rota pública do jusSub. Não enviar o Bearer da plataforma: o jusSub
      // valida qualquer token presente e rejeitaria com 401 mesmo em permitAll.
      const response = await axios.post(
        `${JUSSUB_BASE_URL}/v1/checkout`,
        payload,
        { skipAuthRefresh: true },
      );
      return response;
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'Não foi possível criar o cliente',
      );
      throw error;
    }
  }
}
